var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1458_11552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1458_11552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.20012 20.975C3.85012 21.0583 3.54595 20.9708 3.28762 20.7125C3.02928 20.4542 2.94178 20.15 3.02512 19.8L3.90012 15.55L8.45012 20.1L4.20012 20.975ZM10.0751 18.875L5.12512 13.925L15.4501 3.59999C15.8335 3.21666 16.3084 3.02499 16.8751 3.02499C17.4418 3.02499 17.9168 3.21666 18.3001 3.59999L20.4001 5.69999C20.7834 6.08333 20.9751 6.55833 20.9751 7.12499C20.9751 7.69166 20.7834 8.16666 20.4001 8.54999L10.0751 18.875Z",
    fill: "#EAD40C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d79e28e9721646aa03a90bde941c6820.svg";
export { ForwardRef as ReactComponent };